import React from 'react';

const SubThemeExpanded = ({ subTheme, theme, color, progress, studiedCountToday, totalStudiedCount, sessionCountToday, totalSessionCount, onStart }) => {
  return (
    <div className="sub-theme-expanded expanded">
      <div className="sub-theme-expanded-inner" style={{ background: color }}>
        <h2 className="expanded-title">{`${subTheme}`}</h2>
        <p className="expanded-info">Score: {progress.toFixed(2)}%</p>
        <p className="expanded-info">Flashcards étudiées aujourd'hui: {studiedCountToday}</p>
        <p className="expanded-info">Flashcards étudiées (total): {totalStudiedCount}</p>
        <p className="expanded-info">Sessions aujourd'hui: {sessionCountToday}</p>
        <p className="expanded-info">Sessions (total): {totalSessionCount}</p>
        <button
          className="start-session-btn"
          onClick={onStart}
          style={{
            background: color === '#f39c12' || color === '#ff9800' ? '#333' : '#fff',
            color: color === '#f39c12' || color === '#ff9800' ? '#fff' : '#333',
          }}
        >
          Commencer une session
        </button>
      </div>
    </div>
  );
};

export default SubThemeExpanded;